import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled from '@xstyled/styled-components';
import { PrimaryButton, SecondaryButton, getSize } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledListWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('padding16'));
var StyledButtonGroup = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  padding: ", " 0 150px;\n  flex-grow: 2;\n"])), getSize('padding24'));
export var QuestionDisplayAsList = function QuestionDisplayAsList(_ref) {
  var children = _ref.children,
      onPreviousSection = _ref.onPreviousSection,
      onNextSection = _ref.onNextSection,
      _ref$isFirstSection = _ref.isFirstSection,
      isFirstSection = _ref$isFirstSection === void 0 ? false : _ref$isFirstSection,
      _ref$isLastSection = _ref.isLastSection,
      isLastSection = _ref$isLastSection === void 0 ? false : _ref$isLastSection,
      navigationLabels = _ref.navigationLabels;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledListWrapper, {
      children: children
    }), navigationLabels && /*#__PURE__*/_jsxs(StyledButtonGroup, {
      children: [/*#__PURE__*/_jsx(SecondaryButton, {
        disabled: isFirstSection,
        onClick: onPreviousSection,
        children: navigationLabels.previousSection || 'Previous Section'
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        disabled: isLastSection,
        onClick: onNextSection,
        children: navigationLabels.nextSection || 'Next Section'
      })]
    })]
  });
};